import React, { FC } from 'react';
import { Box } from '@mui/material';
import { grey } from '@mui/material/colors';

import { FeesChanges } from './FeesChanges';
import { ProposalChanges } from './ProposalChanges';
import { ContactsChanges } from './ContactsChanges';
import { EquipmentChanges } from './EquipmentChanges';
import { FinanceAndMenuChanges } from './FinanceAndMenuChanges';
import { EquipmentTradeInsChanges } from './EquipmentTradeInsChanges';

interface Props {
  changeKey: string;
  value: Record<string, any>;
}

export const Changes = ({ changeKey, value }: Props) => {
  const renderByType: Record<string, FC<{ value: Record<string, any> }>> = {
    fees: FeesChanges,
    proposal: ProposalChanges,
    contacts: ContactsChanges,
    equipment: EquipmentChanges,
    financeAndMenu: FinanceAndMenuChanges,
    equipmentTradeIns: EquipmentTradeInsChanges,
  };

  const Component = renderByType[changeKey];

  if (!Component) return null;

  return (
    <Box
      sx={({ shadows }) => ({
        boxShadow: shadows[1],
        borderRadius: '0.2rem',
        padding: '0.2rem 0.4rem',
        border: `1px solid ${grey[300]}`,
      })}
    >
      <Component value={value} />
    </Box>
  );
};
